export default __webpack_public_path__ + "static/media/ic_ftm_24.562d9781.svg";